import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import HomePage from "./HomePage";
import LoginPage from "./LoginPage";
import SignUpPage from "./SignUpPage";
import MatrixOSEnterPage from "./MatrixOSEnterPage";
import SecurityPage from "./pages/SecurityPage";

import AdminPanel from "./cashup/AdminPanel";

import SuperAdminRoute from "./super/SuperAdminRoute";
import SuperHome from "./super/SuperHome";
import SuperAdminDashboard from "./super/SuperAdminDashboard";
import SuperOrgsList from "./super/SuperOrgsList";
import SuperTools from "./super/SuperTools";
import SuperDownload from "./super/SuperDownload";
import SuperOrgDetails from "./super/SuperOrgDetails";
import SuperShell from "./super/SuperShell";
import UsagePage from "./super/UsagePage";
import SuperArchivePage from "./super/SuperArchivePage";
import FounderMetricsPage from "./super/FounderMetricsPage";
import SupportDeskPage from "./super/SupportDeskPage";
import ScoutPortalAdminPage from "./super/ScoutPortalAdminPage";
import ScoutLoginPage from "./scouts/ScoutLoginPage";
import ScoutPortalApp from "./scouts/ScoutPortalApp";

import DownloadApp from "./pages/DownloadApp";
import AppSetup from "./pages/AppSetup";
import TrialAgreementPage from "./pages/TrialAgreementPage";
import ContractPage from "./pages/ContractPage";
import ActivateServicePage from "./pages/ActivateServicePage";

import RequireAuth from "./auth/RequireAuth";
import LoginGuard from "./auth/LoginGuard";
import NoAccessPage from "./pages/NoAccessPage";

import LogoutOnLeave from "./auth/LogoutOnLeave";
import ConfirmProvider from "./ui/ConfirmProvider";
import DevAuthButton from "./components/DevAuthButton";

import BookDemo from "./pages/BookDemo";
import FoundingPartner from "./pages/FoundingPartner";
import Products from "./pages/Products";
import SPSLanding from "./pages/SPSLanding";
import SCSLanding from "./pages/SCSLanding";
import PLELanding from "./pages/PLELanding";
import MorphiusCount from "./pages/MorphiusCount";
import MorpheusCountLanding from "./pages/MorpheusCountLanding";
import MorpheusCountWorkspace from "./mc/pages/MorpheusCountWorkspace";
import MorpheusCountSessions from "./mc/pages/MorpheusCountSessions";
import MorpheusCountSessionDetail from "./mc/pages/MorpheusCountSessionDetail";
import MorpheusCountImports from "./mc/pages/MorpheusCountImports";
import MorpheusCountMapping from "./mc/pages/MorpheusCountMapping";
import MorpheusCountCategories from "./mc/pages/MorpheusCountCategories";
import MorpheusCountConfig from "./mc/pages/MorpheusCountConfig";
import MorpheusCountPreparedData from "./mc/pages/MorpheusCountPreparedData";
import MorpheusCountArchive from "./mc/pages/MorpheusCountArchive";
import MorpheusCountChrome from "./mc/components/MorpheusCountChrome";
import MorpheusProfileGate from "./mc/components/MorpheusProfileGate";
import MorpheusCountProfiles from "./mc/pages/MorpheusCountProfiles";
import MorpheusCountSites from "./mc/pages/MorpheusCountSites";
import MorpheusCountSections from "./mc/pages/MorpheusCountSections";

import DebugAuthPage from "./pages/DebugAuthPage";

import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Billing from "./pages/Billing";
import AcceptableUse from "./pages/AcceptableUse";
import DataProcessing from "./pages/DataProcessing";
import Contact from "./pages/Contact";
import Discovery from "./pages/Discovery";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Faq from "./pages/Faq";
import PasswordActionPage from "./pages/PasswordActionPage";
import OnTimeRoute from "./auth/OnTimeRoute";
import OnTimeShell from "./ontime/components/OnTimeShell";
import OnTimeControlTowerPage from "./ontime/pages/OnTimeControlTowerPage";
import OnTimeControlMapPage from "./ontime/pages/OnTimeControlMapPage";
import OnTimeControlTowerQueuePage from "./ontime/pages/OnTimeControlTowerQueuePage";
import OnTimeIntakePage from "./ontime/pages/OnTimeIntakePage";
import OnTimeStoreQueuePage from "./ontime/pages/OnTimeStoreQueuePage";
import OnTimeDriverPage from "./ontime/pages/OnTimeDriverPage";
import OnTimeReportsPage from "./ontime/pages/OnTimeReportsPage";
import OnTimeSettingsPage from "./ontime/pages/OnTimeSettingsPage";
import OnTimeMyViewPage from "./ontime/pages/OnTimeMyViewPage";
import OnTimeProductsPage from "./ontime/pages/OnTimeProductsPage";
import OnTimeCustomersPage from "./ontime/pages/OnTimeCustomersPage";
import OnTimeArchivesPage from "./ontime/pages/OnTimeArchivesPage";
import OnTimeOrdersPage from "./ontime/pages/OnTimeOrdersPage";
import OnTimeProfilesPage from "./ontime/pages/OnTimeProfilesPage";
import LinkStorePwaPage from "./ontime/pages/LinkStorePwaPage";
import LinkDriverPwaPage from "./ontime/pages/LinkDriverPwaPage";
import LinkCustomerPwaPage from "./ontime/pages/LinkCustomerPwaPage";
import OnTimeAdminPage from "./super/OnTimeAdminPage";
import MatrixOSLayerStoryPage from "./pages/MatrixOSLayerStoryPage";
import NeoLandingPage from "./pages/NeoLandingPage";
import LeagueLandingPage from "./pages/LeagueLandingPage";
import ExploreApp from "./explore/ExploreApp";
import LeagueApp from "./league/LeagueApp";

export default function AppWrapper() {
  const isDev = process.env.NODE_ENV !== "production";
  const isActionLink =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("mode");

  if (process.env.NODE_ENV !== "production") {
    const check = (name, v) => {
      const t = typeof v;
      const ok =
        t === "function" ||
        (t === "object" && v != null && typeof v.$$typeof !== "undefined");
      if (!ok) console.error(`[AppWrapper] BAD IMPORT: ${name}`, v, "typeof:", t);
    };

    check("HomePage", HomePage);
    check("LoginPage", LoginPage);
    check("SignUpPage", SignUpPage);
    check("AdminPanel", AdminPanel);
    check("SuperAdminRoute", SuperAdminRoute);
    check("SuperHome", SuperHome);
    check("SuperAdminDashboard", SuperAdminDashboard);
    check("SuperOrgsList", SuperOrgsList);
    check("SuperTools", SuperTools);
    check("SuperOrgDetails", SuperOrgDetails);
    check("SuperShell", SuperShell);
    check("UsagePage", UsagePage);
    check("FounderMetricsPage", FounderMetricsPage);
    check("SupportDeskPage", SupportDeskPage);
    check("ScoutPortalAdminPage", ScoutPortalAdminPage);
    check("ScoutLoginPage", ScoutLoginPage);
    check("ScoutPortalApp", ScoutPortalApp);
    check("DownloadApp", DownloadApp);
    check("AppSetup", AppSetup);
    check("RequireAuth", RequireAuth);
    check("LoginGuard", LoginGuard);
    check("NoAccessPage", NoAccessPage);
    check("LogoutOnLeave", LogoutOnLeave);
    check("ConfirmProvider", ConfirmProvider);
    check("DevAuthButton", DevAuthButton);
    check("BookDemo", BookDemo);
    check("FoundingPartner", FoundingPartner);
    check("Products", Products);
    check("SPSLanding", SPSLanding);
    check("SCSLanding", SCSLanding);
    check("PLELanding", PLELanding);
    check("MorpheusCountLanding", MorpheusCountLanding);
    check("MorpheusCountWorkspace", MorpheusCountWorkspace);
    check("MorpheusCountSessions", MorpheusCountSessions);
    check("MorpheusCountSessionDetail", MorpheusCountSessionDetail);
    check("MorpheusCountImports", MorpheusCountImports);
    check("MorpheusCountMapping", MorpheusCountMapping);
    check("MorpheusCountCategories", MorpheusCountCategories);
    check("MorpheusCountConfig", MorpheusCountConfig);
    check("MorpheusCountPreparedData", MorpheusCountPreparedData);
    check("MorpheusCountArchive", MorpheusCountArchive);
    check("MorpheusCountSites", MorpheusCountSites);
    check("MorpheusCountSections", MorpheusCountSections);
    check("DebugAuthPage", DebugAuthPage);
    check("Terms", Terms);
    check("Privacy", Privacy);
    check("Billing", Billing);
    check("AcceptableUse", AcceptableUse);
    check("DataProcessing", DataProcessing);
    check("Contact", Contact);
    check("Discovery", Discovery);
    check("About", About);
    check("Pricing", Pricing);
    check("Faq", Faq);
    check("PasswordActionPage", PasswordActionPage);
    check("LinkStorePwaPage", LinkStorePwaPage);
    check("LinkDriverPwaPage", LinkDriverPwaPage);
    check("LinkCustomerPwaPage", LinkCustomerPwaPage);
    check("MatrixOSLayerStoryPage", MatrixOSLayerStoryPage);
    check("NeoLandingPage", NeoLandingPage);
    check("ExploreApp", ExploreApp);
    check("LeagueApp", LeagueApp);
  }

  console.log("LIVE RESET CHECK", window.location.search);

  if (isActionLink) {
    return (
      <ConfirmProvider>
        <LogoutOnLeave />
        <PasswordActionPage />
      </ConfirmProvider>
    );
  }

  const withMorpheusChrome = (element) => (
    <RequireAuth orgRequired appRequired="mc">
      <MorpheusCountChrome>
        <MorpheusProfileGate>{element}</MorpheusProfileGate>
      </MorpheusCountChrome>
    </RequireAuth>
  );

  return (
    <ConfirmProvider>
      <LogoutOnLeave />
      <DevAuthButton />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/matrixos-enter" element={<MatrixOSEnterPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/acceptable-use" element={<AcceptableUse />} />
        <Route path="/data-processing" element={<DataProcessing />} />
        <Route path="/legal/acceptable-use" element={<Navigate to="/acceptable-use" replace />} />
        <Route path="/legal/data-processing" element={<Navigate to="/data-processing" replace />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/discovery" element={<Discovery />} />
        <Route path="/about" element={<About />} />
        <Route path="/explore/*" element={<ExploreApp />} />
        <Route path="/neo" element={<NeoLandingPage />} />
        <Route path="/league/*" element={<LeagueApp />} />
        <Route path="/products/neo" element={<NeoLandingPage />} />
        <Route path="/products/league" element={<LeagueLandingPage />} />

        <Route path="/products" element={<Products />} />
        <Route path="/morphius-count" element={<MorphiusCount />} />
        <Route path="/morpheus-count" element={<Navigate to="/products/mc" replace />} />
        <Route path="/products/mc" element={<MorpheusCountLanding />} />
        <Route path="/morpheus-count/workspace" element={withMorpheusChrome(<MorpheusCountWorkspace />)} />
        <Route path="/morpheus-count/sessions" element={withMorpheusChrome(<MorpheusCountSessions />)} />
        <Route path="/morpheus-count/session/:sessionId" element={withMorpheusChrome(<MorpheusCountSessionDetail />)} />
        <Route path="/morpheus-count/imports" element={withMorpheusChrome(<MorpheusCountImports />)} />
        <Route path="/morpheus-count/mapping" element={withMorpheusChrome(<MorpheusCountMapping />)} />
        <Route path="/morpheus-count/categories" element={withMorpheusChrome(<MorpheusCountCategories />)} />
        <Route path="/morpheus-count/config" element={withMorpheusChrome(<MorpheusCountConfig />)} />
        <Route path="/morpheus-count/prepared-data" element={withMorpheusChrome(<MorpheusCountPreparedData />)} />
        <Route path="/morpheus-count/archive" element={withMorpheusChrome(<MorpheusCountArchive />)} />
        <Route path="/morpheus-count/sites" element={withMorpheusChrome(<MorpheusCountSites />)} />
        <Route path="/morpheus-count/sections" element={withMorpheusChrome(<MorpheusCountSections />)} />
        <Route path="/morpheus-count/profiles" element={withMorpheusChrome(<MorpheusCountProfiles />)} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/products/sps" element={<SPSLanding />} />
        <Route path="/products/scs" element={<Navigate to="/products/mc" replace />} />
        <Route path="/products/ple" element={<PLELanding />} />

        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/founding-partner" element={<FoundingPartner />} />
        <Route path="/sps" element={<Navigate to="/products/sps" replace />} />

        <Route path="/trial-agreement" element={<TrialAgreementPage />} />
        <Route path="/contract" element={<ContractPage />} />
        <Route path="/activate-service" element={<ActivateServicePage />} />

        <Route
          path="/login"
          element={
            <LoginGuard>
              <LoginPage />
            </LoginGuard>
          }
        />
        <Route
          path="/ontime-login"
          element={<Navigate to="/login" state={{ preferredApp: "ontime" }} replace />}
        />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/scouts/login" element={<ScoutLoginPage />} />
        <Route path="/scouts/*" element={<ScoutPortalApp />} />

        {isDev && <Route path="/debug-auth" element={<DebugAuthPage />} />}

        <Route
          path="/cashup/*"
          element={
            <RequireAuth orgRequired appRequired="neo">
              <AdminPanel />
            </RequireAuth>
          }
        />
        <Route path="/dashboard/*" element={<Navigate to="/cashup" replace />} />
        <Route path="/download" element={<DownloadApp />} />
        <Route path="/app-setup" element={<AppSetup />} />

        <Route path="/super" element={<SuperAdminRoute />}>
          <Route element={<SuperShell />}>
            <Route index element={<SuperHome />} />
            <Route path="founder" element={<FounderMetricsPage />} />
            <Route path="orgs" element={<SuperOrgsList />} />
            <Route path="orgs/new" element={<SuperAdminDashboard />} />
            <Route path="orgs/:orgId" element={<SuperOrgDetails />} />
            <Route path="usage" element={<UsagePage />} />
            <Route path="tools" element={<SuperTools />} />
            <Route path="download" element={<SuperDownload />} />
            <Route path="support" element={<SupportDeskPage />} />
            <Route path="scouts" element={<ScoutPortalAdminPage />} />
            <Route path="ontime" element={<OnTimeAdminPage />} />
            <Route path="archives" element={<SuperArchivePage />} />
          </Route>
        </Route>

        {/* Link control routes */}
        <Route path="/link" element={<OnTimeRoute />}>
          <Route element={<OnTimeShell />}>
            <Route index element={<OnTimeControlTowerPage />} />
            <Route path="map" element={<OnTimeControlMapPage />} />
            <Route path="tower" element={<OnTimeControlTowerQueuePage />} />
            <Route path="orders" element={<OnTimeOrdersPage />} />
            <Route path="intake" element={<OnTimeIntakePage />} />
            <Route path="products" element={<OnTimeProductsPage />} />
            <Route path="customers" element={<OnTimeCustomersPage />} />
            <Route path="archives" element={<OnTimeArchivesPage />} />
            <Route path="store" element={<OnTimeStoreQueuePage />} />
            <Route path="driver" element={<OnTimeDriverPage />} />
            <Route path="reports" element={<OnTimeReportsPage />} />
            <Route path="settings" element={<OnTimeSettingsPage />} />
            <Route path="profiles" element={<OnTimeProfilesPage />} />
            <Route path="my" element={<OnTimeMyViewPage />} />
          </Route>
        </Route>

        {/* New scalable Link URLs: link.matrixos.co.za/control */}
        <Route path="/control" element={<OnTimeRoute />}>
          <Route element={<OnTimeShell />}>
            <Route index element={<OnTimeControlTowerPage />} />
            <Route path="map" element={<OnTimeControlMapPage />} />
            <Route path="tower" element={<OnTimeControlTowerQueuePage />} />
            <Route path="orders" element={<OnTimeOrdersPage />} />
            <Route path="intake" element={<OnTimeIntakePage />} />
            <Route path="products" element={<OnTimeProductsPage />} />
            <Route path="customers" element={<OnTimeCustomersPage />} />
            <Route path="archives" element={<OnTimeArchivesPage />} />
            <Route path="store" element={<OnTimeStoreQueuePage />} />
            <Route path="driver" element={<OnTimeDriverPage />} />
            <Route path="reports" element={<OnTimeReportsPage />} />
            <Route path="settings" element={<OnTimeSettingsPage />} />
            <Route path="profiles" element={<OnTimeProfilesPage />} />
            <Route path="my" element={<OnTimeMyViewPage />} />
          </Route>
        </Route>

        {/* Legacy OnTime URLs now route into Link */}
        <Route path="/ontime" element={<Navigate to="/link" replace />} />
        <Route path="/ontime/map" element={<Navigate to="/link/map" replace />} />
        <Route path="/ontime/tower" element={<Navigate to="/link/tower" replace />} />
        <Route path="/ontime/orders" element={<Navigate to="/link/orders" replace />} />
        <Route path="/ontime/intake" element={<Navigate to="/link/intake" replace />} />
        <Route path="/ontime/products" element={<Navigate to="/link/products" replace />} />
        <Route path="/ontime/customers" element={<Navigate to="/link/customers" replace />} />
        <Route path="/ontime/archives" element={<Navigate to="/link/archives" replace />} />
        <Route path="/ontime/store" element={<Navigate to="/link/store" replace />} />
        <Route path="/ontime/driver" element={<Navigate to="/link/driver" replace />} />
        <Route path="/ontime/reports" element={<Navigate to="/link/reports" replace />} />
        <Route path="/ontime/settings" element={<Navigate to="/link/settings" replace />} />
        <Route path="/ontime/profiles" element={<Navigate to="/link/profiles" replace />} />
        <Route path="/ontime/my" element={<Navigate to="/link/my" replace />} />

        {/* New scalable Link PWA URLs: link.matrixos.co.za/site, /driver, /track/:orderId */}
        <Route path="/access" element={<Navigate to="/site/access" replace />} />
        <Route path="/site/login" element={<LinkStorePwaPage />} />
        <Route path="/site/access" element={<LinkStorePwaPage />} />
        <Route path="/site/*" element={<LinkStorePwaPage />} />
        <Route path="/driver/login" element={<LinkDriverPwaPage />} />
        <Route path="/driver/access" element={<LinkDriverPwaPage />} />
        <Route path="/driver/*" element={<LinkDriverPwaPage />} />
        <Route path="/track/:orderId" element={<LinkCustomerPwaPage />} />
        <Route path="/track" element={<LinkCustomerPwaPage />} />

        {/* Legacy Link PWA URLs kept alive for existing installs/bookmarks */}
        <Route path="/link-store/*" element={<LinkStorePwaPage />} />
        <Route path="/link-driver/*" element={<LinkDriverPwaPage />} />
        <Route path="/link-customer/*" element={<LinkCustomerPwaPage />} />

        <Route path="/no-access" element={<NoAccessPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConfirmProvider>
  );
}
